import { Injectable } from "@angular/core";
import { AuthenticationModel, ChatConverter, ChatEndPoints, CheckUtils, ConversationsMessagesModel, ConversationsModel, EncryptStorageEvent, FilesModel, logger, MessagesPageApiData, OrganizationModel, UpdateModelVoData } from "../..";
import { Events } from "ionic-angular";
import { FilesConverter } from "../../utils/converter/files-converter";
import { ConversationsByJabberIdsApiData } from "../../end-points-dto/api-dto/chat/conversations-by-jabber-ids-api-data";
var ConversationsMessagesProvider = /** @class */ (function () {
    function ConversationsMessagesProvider(_chatEndPoints, _model, _filesModel, _organizationModel, _conversationModel, _authModel, events) {
        this._chatEndPoints = _chatEndPoints;
        this._model = _model;
        this._filesModel = _filesModel;
        this._organizationModel = _organizationModel;
        this._conversationModel = _conversationModel;
        this._authModel = _authModel;
        this.events = events;
        this._ready = false;
        this.bind();
    }
    ConversationsMessagesProvider.prototype.bind = function () {
        var _this = this;
        this.events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this.events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
        this.events.subscribe(this._model.event.LOADED, function () {
            _this._ready = true;
            _this.events.publish(ConversationsMessagesProviderEvent.READY, _this._ready);
        });
    };
    Object.defineProperty(ConversationsMessagesProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConversationsMessagesProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsMessagesProvider.prototype.loadPage = function (conversation, offset, limit, callback) {
        var _this = this;
        if (CheckUtils.areEmpty(this._model, conversation.id))
            callback([]);
        this._chatEndPoints.messagesPage(new MessagesPageApiData(conversation.id, this._organizationModel.cpId, offset, limit, this._authModel.authenticationToken))
            .then(function (res) { return _this.onLoad(conversation, res, callback); })
            .catch(function (err) {
            _this.onLoad(conversation, null, callback);
            logger.warn(err);
        });
    };
    ConversationsMessagesProvider.prototype.markMessagesAsRead = function (conversation, callback) {
        var _this = this;
        if (CheckUtils.isEmpty(conversation) || CheckUtils.isEmpty(conversation.unReadMessagesId)) {
            if (callback != null)
                callback(false);
            return;
        }
        this._chatEndPoints.markMessagesAsRead(new ConversationsByJabberIdsApiData(conversation.unReadMessagesId, this._authModel.authenticationToken))
            .then(function (res) {
            if (res) {
                conversation.unReadMessagesId = [];
                _this._conversationModel.update(conversation.uid, [new UpdateModelVoData("unReadMessagesId", conversation.unReadMessagesId)]);
            }
            if (callback != null)
                callback(res);
        })
            .catch(function (err) {
            if (callback != null)
                callback(false);
            logger.warn(err);
        });
    };
    ConversationsMessagesProvider.prototype.get = function (messagesId, callback) {
        var result = [];
        if (CheckUtils.isEmpty(messagesId))
            return result;
        for (var _i = 0, _a = Array.from(messagesId); _i < _a.length; _i++) {
            var messageId = _a[_i];
            var message = this._model.get(messageId);
            if (CheckUtils.isEmpty(message))
                logger.warn("Error on get message in conversation-message. Message is not defined.");
            else
                result.push(message);
        }
        callback(result);
    };
    ConversationsMessagesProvider.prototype.onLoad = function (conversation, result, callback) {
        var messages = [];
        if (!CheckUtils.isEmpty(result) && !CheckUtils.isEmpty(result.items)) {
            var _loop_1 = function (item) {
                var messageVoData = ChatConverter.convertToMessageVoData(item);
                var fileVoData = FilesConverter.convertToFilesVoData(item.attachments);
                fileVoData.forEach(function (file) { return messageVoData.files.push(file.uid); });
                this_1._filesModel.addAll(fileVoData);
                messageVoData.valid = true;
                messages.push(messageVoData);
            };
            var this_1 = this;
            for (var _i = 0, _a = result.items; _i < _a.length; _i++) {
                var item = _a[_i];
                _loop_1(item);
            }
            this._model.addAll(messages);
            this.addMessages(conversation, messages);
        }
        callback(messages);
    };
    ConversationsMessagesProvider.prototype.addMessages = function (conversation, messagesVoData) {
        for (var _i = 0, messagesVoData_1 = messagesVoData; _i < messagesVoData_1.length; _i++) {
            var messageVoData = messagesVoData_1[_i];
            if (conversation.messagesId.indexOf(messageVoData.uid) == -1) {
                conversation.messagesId.push(messageVoData.uid);
            }
        }
        this._conversationModel.update(conversation.uid, [new UpdateModelVoData("messagesId", conversation.messagesId)]);
    };
    ConversationsMessagesProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConversationsMessagesProvider.ctorParameters = function () { return [
        { type: ChatEndPoints, },
        { type: ConversationsMessagesModel, },
        { type: FilesModel, },
        { type: OrganizationModel, },
        { type: ConversationsModel, },
        { type: AuthenticationModel, },
        { type: Events, },
    ]; };
    return ConversationsMessagesProvider;
}());
export { ConversationsMessagesProvider };
export var ConversationsMessagesProviderEvent;
(function (ConversationsMessagesProviderEvent) {
    ConversationsMessagesProviderEvent["READY"] = "conversations-messages-provider:ready";
})(ConversationsMessagesProviderEvent || (ConversationsMessagesProviderEvent = {}));
//# sourceMappingURL=conversations-messages-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/chat/conversations-messages-provider.js
// module id = 344
// module chunks = 14